import { forwardRef } from 'react';

import { Input } from '../ui/Input';
import { cn } from '../../utils/cn';

/**
 * NumericInput pt-PT-friendly:
 *  - aceita virgula como decimal
 *  - inputMode="decimal" → teclado numerico no mobile
 *  - filtra teclas nao numericas
 */
export const NumericInput = forwardRef(function NumericInput(
  { className, allowNegative = false, value, onChange, ...props },
  ref,
) {
  const handleChange = (event) => {
    let next = event.target.value;
    // Permite apenas digitos, virgula, ponto e (opcionalmente) sinal negativo
    const validPattern = allowNegative ? /[^0-9.,-]/g : /[^0-9.,]/g;
    next = next.replace(validPattern, '');
    // Apenas um separador decimal — preferir virgula
    next = next.replace(/\.(?=.*[.,])/g, '');
    next = next.replace(/,(?=.*,)/g, '');
    onChange?.({ ...event, target: { ...event.target, value: next } });
  };

  // Sem `value` → input não controlado (compatível com react-hook-form register).
  const controlled = value !== undefined && value !== null;

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="decimal"
      enterKeyHint="done"
      className={cn('tnum text-right', className)}
      {...props}
      {...(controlled ? { value } : {})}
      onChange={handleChange}
    />
  );
});
